export default __webpack_public_path__ + "static/media/download.7d44f6e4.svg";